import { useCallback, useEffect, useState } from "react";
import logger from "../../../../utils/logger";
import { FormationService } from "../../../../services/formationService";


export const useFormationController = (id) => {

    const [formationDataById, setFormationDataById] = useState([])
    const [loading, setLoading] = useState(false)



    const callFormationData = useCallback(async () => {
        if (!id) return
        setLoading(true)

        try {
            const response = await FormationService.getFormationById(id)
            if (response) {

                logger.debug('formation controller response: ', response)

                const unifiedMembers = [

                    ...response.formation.members.map(m => {
                        const { member, ...rest } = m; //👉 ...rest captura lo que resta y se saca a member


                        return {
                            ...rest,      //? todo menos member
                            ...member,    //? desparrama el contenido de member
                            isActive: true
                        };
                    }),
                    ...response.membersToInvite.map(m =>
                        ({ ...m, isActive: false })
                    )
                ]





                const { members, ...formationRest } = response.formation



                //?se crea una propiedad "fullName" con el nombre completo para el buscador activo
                const normalizedMembers = unifiedMembers.map(n => {

                    const normalized = {
                        ...n,
                        fullName: `${n.name ?? ""} ${n.lastname ?? ""}`
                    }

                    return normalized

                })


                // logger.debug('normalizedMembers: ', normalizedMembers)

                const allUnified = {
                    allUsers: normalizedMembers,
                    formationData: formationRest,
                    activeMembersLength: response.formation?.members.length

                }

                logger.debug('allUnified: ', allUnified)

                setFormationDataById(allUnified)
                setLoading(false)
            }
        } catch (error) {
            logger.error('error de busqueda', error);

        }

    }, [id])

    useEffect(() => {

        callFormationData()

    }, [id])

    logger.debug('formationDataById: ', formationDataById)

    return { formationDataById, loading , refetch: callFormationData}
}
